<template>
  <v-sheet
    color="white"
    elevation="5"
    rounded
    class="mt-5 mb-5 pt-3 pb-5 pl-3 pr-3">
    <div class="profile-content">
      <v-tabs v-model="tab">
        <v-tab key="dogTypes">
          Dog Types
        </v-tab>
        <v-tab key="memberTypes">
          Member Types
        </v-tab>
        <v-tab key="nextIds">
          Next IDs
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="dogTypes">
          <DogTypeMaintenance/>
        </v-tab-item>
        <v-tab-item key="memberTypes">
          <MemberTypeMaintenance />
        </v-tab-item>
        <v-tab-item key="nextIds">
          <NextIdsMaintenance />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import DogTypeMaintenance from "@/components/Admin/Lookups/DogTypeMaintenance.vue";
import NextIdsMaintenance from "@/components/Admin/Lookups/NextIdsMaintenance.vue";
import MemberTypeMaintenance from "@/components/Admin/Lookups/MemberTypeMaintenance.vue";

export default Vue.extend({
  name: "IdManagement",
  components: {
    DogTypeMaintenance,
    MemberTypeMaintenance,
    NextIdsMaintenance,
  },
  data: function() {
    return {
      tab: null,
    };
  },
});
</script>
